module.exports = __webpack_public_path__ + "img/double-right-w.d2a9f813.svg";